import React, { forwardRef } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const BRAND_COLOR = '#4DABA4';
export const BRAND_COLOR_DARK = '#3d9993';
export const PROFILE_COLOR = '#7E57C2';

const FormSection = forwardRef(({ step, icon, title, subtitle, action, children }, ref) => (
  <Paper
    ref={ref}
    elevation={0}
    sx={{
      mb: 3,
      borderRadius: 3,
      border: '1px solid',
      borderColor: 'divider',
      overflow: 'hidden',
      scrollMarginTop: 24,
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        px: { xs: 2, md: 3 },
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        background: `linear-gradient(90deg, ${BRAND_COLOR}14 0%, transparent 70%)`,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: 2,
          display: 'grid',
          placeItems: 'center',
          bgcolor: BRAND_COLOR,
          color: '#fff',
          position: 'relative',
        }}
      >
        {icon}
        {step !== undefined && (
          <Box
            sx={{
              position: 'absolute',
              top: -6,
              right: -6,
              width: 20,
              height: 20,
              borderRadius: '50%',
              bgcolor: '#fff',
              color: BRAND_COLOR_DARK,
              border: `2px solid ${BRAND_COLOR}`,
              fontSize: 11,
              fontWeight: 700,
              display: 'grid',
              placeItems: 'center',
            }}
          >
            {step}
          </Box>
        )}
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {action}
    </Stack>
    <Box sx={{ p: { xs: 2, md: 3 } }}>{children}</Box>
  </Paper>
));

export const FieldLabel = ({ children, hint, error }) => (
  <Stack direction="row" alignItems="baseline" justifyContent="space-between" sx={{ mb: 1 }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
      {children}
    </Typography>
    {(hint || error) && (
      <Typography variant="caption" sx={{ color: error ? 'error.main' : 'text.secondary' }}>
        {error || hint}
      </Typography>
    )}
  </Stack>
);

export const editorBoxSx = (height, error) => ({
  border: '1px solid',
  borderColor: error ? 'error.main' : 'divider',
  borderRadius: 2,
  overflow: 'hidden',
  background: '#fff',
  height,
  display: 'flex',
  flexDirection: 'column',
  transition: 'border-color .15s',
  '&:focus-within': { borderColor: BRAND_COLOR, boxShadow: `0 0 0 3px ${BRAND_COLOR}26` },
  '& .ql-toolbar': { border: 'none', borderBottom: '1px solid #eee', background: '#fafbfc' },
  '& .ql-container': { border: 'none', flex: 1, minHeight: 0 },
});

export default FormSection;
